<template>
  <div class="flex flex-col min-h-screen text-deliRed">
    <!-- Player -->
    <Player />

    <div class="flex w-full justify-between items-center px-2 pt-10">
      <div class="pt-2">
        <router-link to="/">
          <img src="@/assets/img/logo.png" class="w-24" />
        </router-link>
      </div>
      <div class="text-2xl">
        <a href="https://soundcloud.com/deliradio-nyc" target="_blank">Archive</a>
      </div>
    </div>

    <!-- Conteúdo principal -->
    <div class="flex-grow lg:p-10 p-1">
      <router-view></router-view>
    </div>

    <!-- Rodapé -->
    <footer class="fixed inset-x-0 bottom-0 flex lg:w-full justify-between items-center lg:px-2 lg:py-2 h-fit backdrop-blur-sm">
      <div class="text-2xl">
        <router-link to="/support">Support</router-link>
      </div>
      <div class="text-2xl">
        <router-link to="/submit">Submit</router-link>
      </div>
    </footer>
  </div>
</template>

<script>
import Player from "@/components/PlayerComponent.vue";

export default {
  name: "App",
  components: {
    Player
  }
};
</script>

<style>
/* Opcional: Se quiser que o rodapé fique fixo no final da tela mesmo com pouco conteúdo */
html,
body {
  height: 100%;
  margin: 0;
}
</style>
